var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"subheader",class:[("hera-subheader--" + _vm.variant)]},[_c('TextBlock',_vm._b({},'TextBlock',Object.assign({}, {size: _vm.size || 1.125,
      variant: _vm.isSecondary ? 'secondary' : _vm.isAccent ? 'accent' : 'primary',
      lineHeight: _vm.size * 1.3 || 1.5,
      text: _vm.text,
      tag: _vm.tag},
      _vm.textBlockProps),false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }